import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const VerificationRequiredModal = ({ show, onClose, title, message }) => (
  <Modal show={show} onHide={onClose} centered>
    <Modal.Header closeButton>
      <Modal.Title>{title || 'Verification Required'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        {message || 'You must complete ID verification before proceeding. Please verify your identity to continue.'}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={onClose}>
        OK
      </Button>
    </Modal.Footer>
  </Modal>
);

VerificationRequiredModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default VerificationRequiredModal;
